// import { createSelector } from 'reselect';

export const getIsPosting = state => state.getIn(['appointmentCase', 'isPosting']);
export const getIsPutting = state => state.getIn(['appointmentCase', 'isPutting']);
export const getIsDeleting = state => state.getIn(['appointmentCase', 'isDeleting']);
export const getErrMsg = state => state.getIn(['appointmentCase', 'errMsg']);

export const getCaseRelateList = state => state.getIn(['appointmentCase', 'caseRelateList']);
export const getIsGettingCaseRelated = state => state.getIn(['appointmentCase', 'isGettingCaseRelated']);